import styled, { keyframes } from "styled-components";

const animationSkelletonLoader = keyframes`
    to {
        filter: brightness(105%);
    }
`;
export const SkelletonLoader = styled.tr`
    td { padding: 0; }
    div {
        height: 12vh;
        margin: 5px 0;
        max-height: 89px;
        background-color: var(--light-blue-1);
        animation: linear 0.5s ${animationSkelletonLoader} alternate-reverse infinite;
        position: relative;
        z-index: -1;
        border-radius: 4px;
    }
    &:first-child div { margin-top: 0; }
    &:last-child div { margin-bottom: 0; }
`;